import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

/** Zero-height menu row drawn as a dark rule, separating groups of options inside a Select. */
export const MenuItemDivider = styled(MenuItem)(({ theme }) => ({
  paddingTop: 0,
  paddingBottom: 0,
  minHeight: 0,
  borderBottom: '1px solid',
  borderColor: theme.palette.grey[800],
}));
